import { render, staticRenderFns } from "./magento-plugin-page.vue?vue&type=template&id=cf679e08&scoped=true"
import script from "./magento-plugin-page.vue?vue&type=script&lang=js"
export * from "./magento-plugin-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf679e08",
  null
  
)

export default component.exports